import { render, staticRenderFns } from "./MenuOptions.vue?vue&type=template&id=52f50091&"
import script from "./MenuOptions.vue?vue&type=script&lang=js&"
export * from "./MenuOptions.vue?vue&type=script&lang=js&"
import style0 from "./MenuOptions.vue?vue&type=style&index=0&id=52f50091&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports